module.exports = __webpack_public_path__ + "img/img-10.2971d3ef.webp";